import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../features/auth/useAuth';
import Spinner from '../components/Spinner';

interface RoleRouteProps {
  requireAdmin?: boolean;
  children: ReactNode;
}

/** Restricts a route to admins; non-admins are sent to the dashboard. */
export default function RoleRoute({
  requireAdmin = true,
  children,
}: RoleRouteProps) {
  const { currentUser, isAuthenticated, status } = useAuth();
  // Session still resolving — don't mistake it for "not signed in".
  if (status === 'idle' || status === 'loading') {
    return <Spinner fullPage label="Authenticating…" />;
  }
  if (!isAuthenticated || !currentUser)
    return <Navigate to="/auth-error" replace />;
  if (requireAdmin && !currentUser.isAdmin)
    return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
